exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zhL2T1OxYd7tvJ{display:inline-block}._1OOjHSFs1tij6O{padding-right:11px;font-size:18px;vertical-align:middle;overflow-wrap:break-word;display:inline-block}._1OOjHSFs1tij6O,.QCef5hn6FufR49{word-break:break-word;word-wrap:break-word}.QCef5hn6FufR49{flex-direction:column;overflow:hidden;overflow-wrap:break-word}", ""]);

// exports
exports.locals = {
	"smallTeamBoardsBanner": "zhL2T1OxYd7tvJ",
	"boardsPageEmoji": "_1OOjHSFs1tij6O",
	"boardsMenuBanner": "QCef5hn6FufR49"
};